export const round = (number, places=1) => {
    if (isNaN(number)) {
        return number;
    }
    let factor = Math.pow(10, places);
    let x = Math.round(factor*number)/factor;
    return x;
};
